export const MonthlyCommissionStatementsStyles = {
  headingsContainer: {
    display: "flex",
    gap: "90px",
    flexWrap: "wrap",
    "@media screen and (max-width: 1023px)": {
      rowGap: "20px",
      columnGap: "40px",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "25px 30px",
    maxWidth: "1920px",
    margin: "0 auto",
    marginTop: "68px",
    "@media screen and (max-width: 1023px)": {
      padding: "24px 20px",
      marginTop: "60px",
    },
  },
  imageContainer: {
    position: "absolute",
    right: "0",
    display: "none",
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "self-end",
    border: "1px solid var(--shaded-cyan)",
    padding: "30px",
    borderRadius: "8px",
    backgroundColor: "var(--white)",
    "@media screen and (max-width: 1023px)": {
      padding: "20px 16px",
      height: "unset",
    },
  },
  headingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
    "@media screen and (max-width: 1023px)": {
      minWidth: "113px",
    },
  },
  heading: {
    fontSize: "var(--font-size-20)",
    fontWeight: "var(--font-weight-400)",
    color: "var(--primary-black)",
    lineHeight: "27px",
    "@media screen and (max-width: 1023px)": {
      fontSize: "var(--font-size-14)",
      lineHeight: "22px",
    },
  },
  subHeading: {
    fontSize: "var(--font-size-16)",
    fontWeight: "var(--font-weight-300)",
    color: "var(--primary-black)",
    "@media screen and (max-width: 1023px)": {
      fontSize: "var(--font-size-12)",
      lineHeight: "16px",
    },
  },
  image: {
    "> img": {
      width: "20px",
      height: "20px",
    },
  },
  imageAndTextContainer: {
    gap: "4px",
  },
  breadCrumbText: {
    "@media screen and (max-width: 1023px)": {
      fontSize: "var(--font-size-14)",
    },
  },
};
